import { render, staticRenderFns } from "./invoices_detail.vue?vue&type=template&id=6bfdf68a&scoped=true&"
import script from "./invoices_detail.vue?vue&type=script&lang=js&"
export * from "./invoices_detail.vue?vue&type=script&lang=js&"
import style0 from "./invoices_detail.vue?vue&type=style&index=0&id=6bfdf68a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdf68a",
  null
  
)

export default component.exports